<template>
    <div class="ReCCMYBASEObjTable">
		<div class="filter-tag-row">
			<ReFilterBtn v-model="bShowFilter" :bShowOptsCount="false"/>
			<span v-if="this.ApiData" class="ml-3 el-tag el-tag--small el-tag el-tag--plain el-tag--primary">строк: {{masApi_total}}</span>
		</div> 
		
		<div class="row" v-show="bShowFilter">
			<div class="col-12"><ReFilter
				:masAllFilterParams="masAllFilterParams"
				v-model="objGetParams"
				v-on:filterapply="OnFilterApply"
				name="CC_MY_BASE"
			/></div>
		</div>

		<div> 
			<el-table 
				ref="CCObjTable"
				:data="ApiData" 
				style="width: 100%;" 
			>
			<el-table-column
					label="ID"
					property="id"
					min-width="60"
			>
			</el-table-column>
			<el-table-column 
					min-width="130"
					label="№ ячейки"
					property="cell_id"
			>
				<template v-slot="scope">
					<span>[{{(scope.row.mc_id == "")?"Нет ячейки":scope.row.mc_id}}] {{ scope.row.mc_cellName }}</span>
				</template>
			</el-table-column>
			<!-- el-table-column 
					min-width="180"
					label="Объект"
					property="obj_id"
					
			>
				<template slot-scope="scope">
					<a :href="`/data/module/sso/object/second/${scope.row.obj_id}`" >{{ scope.row.obj_id }}</a>
				</template>
			</el-table-column -->
			<el-table-column 
					min-width="240"
					label="Объект"
					property="so_url"
					
			>
				<template v-slot="scope">
					<a :href="`${scope.row.so_url}`" target="_blank" >
						<div class="objectAddress">
							<div class="metro">
								<div class="row flex-nowrap ml-0 mr-2 align-items-top" v-if="typeof scope.row!='undefined' && scope.row.metroName!=null  && scope.row.metroName!=''">
									<i class="tim-ic ic-metro text-primary mr-1"></i>
									<div>метро {{scope.row.metroName}}, </div>
								</div> 								
								<div class="row ml-0 mr-2 align-items-center" v-if="typeof scope.row!='undefined' && scope.row.fromSubway!=null  && scope.row.fromSubway!='' && scope.row.fromSubway !='0.00'">
									{{scope.row.fromSubway}} км									
								</div> 								
							</div>
							<div class="" v-if="typeof scope.row!='undefined' ">{{scope.row.region}}, {{scope.row.address}}</div>
						</div>
					</a>
				</template>
			</el-table-column>
			<el-table-column 
					min-width="90"
					label="Комнат"
					property="roomsCountTotal"
					
			>
			</el-table-column>
			<el-table-column 
					min-width="130"
					label="Цена"
					property="price"
			><template v-slot="scope">{{ $GVO.formatAmount(scope.row.price) }}</template>
			</el-table-column>
			<el-table-column 
					min-width="150"
					label="Агент"
					property="under_fio"
					
			>
			</el-table-column>
			<el-table-column 
					min-width="150"
					label="Клиент"
					property="ClientFioManual"
					
			>
			</el-table-column>
			<el-table-column 
					min-width="180"
					label="Телефон"
					property="ClientPhoneManual"
					
			>
			<template v-slot="scope">
				<span v-if="scope.row.isReplacementPhone==1">Подменный: </span>
					<router-link :to="`/data/CC_MY_BASE/id/${scope.row.id}/edit`" >{{ scope.row.ClientPhoneManual }}</router-link>
				</template>
			</el-table-column>
			<el-table-column 
					min-width="180"
					label="Примечание"
					property="descr"
					
			>
			</el-table-column>
			<el-table-column 
					min-width="100"
					label="Рейтинг"
					property="rating"
			>
			</el-table-column>
			<el-table-column 
					min-width="180"
					label="Дата перезвона"
					property="ReCallDt"
					
			>
				<template v-slot="scope">
					{{ $GVO.convertDateTimeFromMysql(scope.row.ReCallDt) }}
				</template>
			</el-table-column>
			<el-table-column 
					min-width="140"
					label="Статус"
					property="status_id"
			>
				<template v-slot="scope">
					<span :class="[
						{'text-warning': scope.row.status_id==2},
						{'text-danger': scope.row.status_id==4},
						{'text-danger': scope.row.status_id==5},
						{'text-danger': scope.row.status_id==6},
						{'text-success': scope.row.status_id==3},
						{'text-primary': scope.row.status_id==1},
					]">{{ GetStatusName(scope.row.status_id) }}</span>
				</template>
			</el-table-column>
			<el-table-column 
					min-width="60"
					label="ХЗ"
					property="show_cc"
			>
				<template v-slot="scope">
					<i v-if="scope.row.show_cc" class="tim-ic ic-eye"></i>
					<i v-else class="el-icon-lock"></i>
				</template>
			</el-table-column>
			<!--el-table-column 
					min-width="180"
					label="Приватнось"
					property="act"
					
			>
			</el-table-column-->
			<!-- 
			<el-table-column
					width="160"
					label="Действие"
					align="right"                    	
			>
					<template slot-scope="scope">			
							<el-tooltip content="Изменить" placement="top">
								<el-button class="no-border my-0">
									<button class="ml-3 btn btn-icon btn-simple btn-success" @click="GoEdit(scope.row)">
										<i class="tim-icons icon-book-bookmark"></i>
									</button>											
								</el-button>
							</el-tooltip>		
							<el-tooltip content="Удалить" placement="top">
								<el-button class="no-border my-0">
									<button class="ml-3 btn btn-icon btn-simple btn-danger" @click="DeleteRow(scope.row)">
										<i class="tim-icons icon-trash-simple"></i>
									</button>											
								</el-button>
							</el-tooltip>		
					</template>
			</el-table-column>
			-->
			</el-table>
		</div>
		<Pagination class="mt-3" :class="[{'': parseInt(masApi_total) > 0}, {'d-none': parseInt(masApi_total) < 1}]"
			:type="'info'" 
			:total="parseInt(masApi_total)" 
			:perPage="parseInt(10)"
			:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
			:pClick="pClick">
		</Pagination>
    </div>
</template>
<script>

/* Сломалась реактивность на объекте или массиве: 
	Этот чудесный кослыль родился потому что VUE не может нормально следить за массивами и теряется реактивность
	https://v2.vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats

Для объекта:
	this.$set(this.objChosenTP,this.ApiData[i].siteId, {'choise':'','cost':0, 'phone':{"contact_id":"","contact_type":"1","contact_value":"","contact_view":"","contact_group":"phone"}});
Для Массива:
	Vue.set(this.masCheckListParams,obj_index, [{val_id:obj_index, elements: masElements}]);
*/

import {eventEmitter} from "src/plugins/globalComponents.js";
import { Table, TableColumn,  Select, Option, Tooltip, Button } from 'element-ui';
import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';
import Pagination from 'src/our_components/RePagination';

export default {
	name: 'CC_MY_BASE-page',
	components: {
	    [Table.name]: Table,
    	[TableColumn.name]: TableColumn,
        [Option.name]: Option,
        [Select.name]: Select,
        [Tooltip.name]: Tooltip,
        [Button.name]: Button,
		ReFilterBtn,
        ReFilter,
        Pagination,
	},
	data() {
		return {
			ApiData: [],
			bShowFilter: false,
			objGetParams: {},
			masAllFilterParams: this.currentFilterConfig(),
			masApi_total:0,
			masCCStatus: [],
		};
	},
	methods: {
		GetStatusName(status_id){
			let status_name = status_id;
				for (let i = 0; i < this.masCCStatus.length; i++) {
					if(this.masCCStatus[i].value == status_id){
						status_name = this.masCCStatus[i].label;
					}	
				}
			return status_name;
		},
		GoToCC(rowData){
			//location.href = `/data/CC_MY_BASE/id/${rowData.id}/edit`; 
			this.$router.push({path: `/data/CC_MY_BASE/id/${rowData.id}/edit`});
		},
		currentFilterConfig(){
			this.$GVO.ApiCall('CC_MY_BASE.GET_FILTER',{})
				.then((objApi) => {
					//console.log(objApi);
					if(objApi.success){
						//this.masAllFilterParams = objApi.config;
						this.masAllFilterParams = this.$GVO.unlinkObject(objApi.config);
						eventEmitter.$emit('OnFilterConfigLoad', this.masAllFilterParams);
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		getApiData(){
			this.objGetParams = this.$GVO.GetAllGet();
			let filter = {};
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				filter = this.$GVO.SafeParseJson(JSON.stringify(this.objGetParams));
			}

			this.masApi_total = 0;
			this.ApiData = [];
			this.$GVO.ApiCall('CC_MY_BASE.GET',{flt:{...filter, c2p:10}})
			.then((objApi) => {
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.ApiData = objApi.data;
						this.masApi_total = objApi.total;
					}else{
						this.masApi_total = 0;
					}
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		pClick(e){
			/*
			let strItogGetParams = '';
			let objItogGetParams = this.$GVO.GetAllGet();
			objItogGetParams.p=parseInt(e);
			strItogGetParams = this.$GVO.ObjToQueryString(objItogGetParams).substr(1);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
			this.getApiData();
			*/
			this.objGetParams['p'] = parseInt(e);
			this.OnFilterApply();
		},
		OnFilterApply(data){
			// console.trace('filter apply'); // При открытии страницы происходит применение фильтра и из-за этого слетает пагинация
			/*
			if(typeof data != 'undefined' && typeof this.objGetParams['p'] != 'undefined'){
				delete this.objGetParams['p'];
			}
			*/

			for (const key in this.objGetParams) {
				if (Object.hasOwnProperty.call(this.objGetParams, key)) {
					if(this.objGetParams[key] == '') delete this.objGetParams[key];
				}
			}
			let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
			//console.log('OnFilterApply',strItogGetParams,this.objGetParams);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
			eventEmitter.$emit('OnFilterApply', this.objGetParams);
			this.getApiData();
		},
	},		
	mounted() {
		this.$GVO.LoadCatPromise('cat_cc_my_base_status').then((ret)=>{
			this.masCCStatus = this.$GVO.getCatToSelect('cat_cc_my_base_status');
			this.getApiData();
		}).catch(errorRet => console.error(errorRet));
	}
};
</script>
<style>
	.objectAddress {display: flex; flex-wrap: wrap;}
	.metro {display: flex; align-items: center; flex-wrap: wrap;}
	.metroIc {margin-right: 7px;}
	.metroIc {margin-bottom: 8px;}
	.service-title {display: flex; flex-wrap: wrap;}
	.marker::before {
		content: "\20DD";
		color: #01B0E0;
		padding-right: 18px;
		font-size: 12px;
		font-weight: normal;
	}
</style>
<style scoped>
	i.tim-ic {font-size: 1.1rem; margin-top: 5px; display: block;}
	.overline { position: relative;}
	.overline::after { 
		content: "╱";
		position: absolute;
		font-size: .85em;
		top: -1px;
		left: 5px;
	}

</style>
